import { useState, useEffect, useContext, useRef } from "react";
import { useTheme } from "@emotion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as IconeExpandir } from "../../assets/icons/expand_more.svg";
import { ItemAdicionarDashboard, ItemMenu } from "./styles";
import styled from "@emotion/styled";
import { useLocation } from "react-router-dom";

const ContainerNaoSelecionavel = styled.div`
  user-select: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .icone-menu {
    color: ${(props) => props.theme.cores.textoSimples};
    fill: ${(props) => props.theme.cores.textoSimples};
    ${(props) =>
      props.aberto && `animation: trocarCor 0.3s ease-in-out forwards`};

    &-baixo {
      transform: rotate(0deg);
    }

    &-esquerda {
      transform: rotate(90deg);
    }
  }

  .icone-menu-painel-transicao-inverter {
    ${(props) =>
      props.$aberto && `animation: girarIcone 0.3s ease-in-out forwards`};
  }

  @keyframes girarIcone {
    0% {
      transform: rotate(0deg);
      fill: ${(props) => props.theme.cores.textoSimples};
    }
    100% {
      transform: rotate(180deg);
      fill: ${(props) => props.theme.cores.brand40Default};
    }
  }

  @keyframes trocarCor {
    0% {
      color: ${(props) => props.theme.cores.textoSimples};
      fill: ${(props) => props.theme.cores.textoSimples};
    }
    100% {
      color: ${(props) => props.theme.cores.brand40Default};
      fill: ${(props) => props.theme.cores.brand40Default};
    }
  }
`;

const ComponentePaginado = ({
  Filho,
  navegacaoInicial,
  Separador = () => <></>,
  mobile = false,
  onItemClick,
}) => {
  const theme = useTheme();
  const [navegacao, setNavegacao] = useState(navegacaoInicial);
  const [expandido, setExpandido] = useState({});
  const location = useLocation();
  const containerRef = useRef(null);

  useEffect(() => {
    setNavegacao(navegacaoInicial);
  }, [navegacaoInicial]);
  const scrollToExpandedItem = (itemElement) => {
    if (!itemElement) return;

    let scrollContainer = itemElement;
    while (scrollContainer && scrollContainer.parentElement) {
      const computedStyle = window.getComputedStyle(scrollContainer);
      const hasOverflow =
        computedStyle.overflowY === "auto" ||
        computedStyle.overflowY === "scroll";
      const isPopupContent =
        scrollContainer.className &&
        scrollContainer.className.includes("popup-content");
      const hasMaxHeight =
        computedStyle.maxHeight && computedStyle.maxHeight !== "none";

      if (hasOverflow || isPopupContent || hasMaxHeight) {
        break;
      }
      scrollContainer = scrollContainer.parentElement;
    }

    if (
      scrollContainer &&
      scrollContainer.scrollHeight > scrollContainer.clientHeight
    ) {
      setTimeout(() => {
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = itemElement.getBoundingClientRect();
        const itemTop =
          itemRect.top - containerRect.top + scrollContainer.scrollTop;
        const TARGET_POSITION = 60;
        const scrollTop = itemTop - TARGET_POSITION;
        const maxScroll =
          scrollContainer.scrollHeight - scrollContainer.clientHeight;
        const finalScrollTop = Math.max(0, Math.min(scrollTop, maxScroll));

        scrollContainer.scrollTo({
          top: finalScrollTop,
          behavior: "smooth",
        });
      }, 50);
    }
  };

  const toggleExpandir = (index, temFilhos, nome, itemElement) => {
    if (temFilhos) {
      const isCurrentlyExpanded = expandido[nome + index];

      setExpandido((prevState) => ({
        ...prevState,
        [nome + index]: !prevState[nome + index],
      }));

      if (!isCurrentlyExpanded && itemElement) {
        requestAnimationFrame(() => {
          setTimeout(() => {
            scrollToExpandedItem(itemElement);
          }, 150);
        });
      }
    }
  };
  const intercalar = (array, Separador) => {
    let resultado = [];
    for (let i = 0; i < array.length; i++) {
      resultado.push(array[i]);
      if (i !== array.length - 1) {
        resultado.push(<Separador key={i} />);
      }
    }
    return resultado;
  };

  const tipoAdicionarDashboard = (texto) => {
    try {
      if (texto === "ativo") {
        return <></>;
      }

      if (texto === "Novo") {
        return (
          <ItemAdicionarDashboard>
            Novo
            <FontAwesomeIcon
              icon={faCirclePlus}
              style={{ color: theme.cores.neutral100 }}
              fontSize={19}
            />
          </ItemAdicionarDashboard>
        );
      }

      return <ItemMenu>{texto}</ItemMenu>;
    } catch (e) {}
  };

  const mapearBotoesNavegacao = (nav) => {
    if (!nav || nav.length === 0 || Object.values(nav).length === 0) {
      return <></>;
    }

    let botoes = nav?.map((item, index) => {
      if (!item) return <></>;
      const nome = item.nome;
      const filhos = item.filhos || [];
      const estaExpandido = expandido[nome + index];
      const temFilhos = filhos.length > 0;
      const oculto = item.oculto;

      if (oculto) {
        return <></>;
      }
      return (
        <div style={{ width: "100%" }} key={index + nome + "navegacao"}>
          <Filho texto={nome}>
            <div
              onClick={(event) => {
                event.stopPropagation();
                const itemContainer = event.currentTarget.closest(
                  'div[style*="width: 100%"]',
                );
                toggleExpandir(index, temFilhos, nome, itemContainer);
                if (!temFilhos && item.onClick) {
                  item.onClick(event);
                  setExpandido({});
                  if (onItemClick) onItemClick();
                }
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {tipoAdicionarDashboard(nome, filhos.length > 0)}
              {temFilhos && (
                <IconeExpandir
                  className={`icone-menu ${
                    estaExpandido ? "icone-menu-baixo" : "icone-menu-esquerda"
                  }`}
                />
              )}
            </div>
          </Filho>

          {estaExpandido && temFilhos && (
            <div
              style={{
                marginLeft: "16px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {mapearBotoesNavegacao(filhos)}
            </div>
          )}
        </div>
      );
    });

    return intercalar(botoes, Separador);
  };

  return (
    <ContainerNaoSelecionavel ref={containerRef}>
      {mapearBotoesNavegacao(navegacao)}
    </ContainerNaoSelecionavel>
  );
};

export default ComponentePaginado;
